import { render, staticRenderFns } from "./warn_info.vue?vue&type=template&id=1d79762d&scoped=true"
import script from "./warn_info.vue?vue&type=script&lang=ts"
export * from "./warn_info.vue?vue&type=script&lang=ts"
import style0 from "./warn_info.vue?vue&type=style&index=0&id=1d79762d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d79762d",
  null
  
)

export default component.exports